




















import { Vue, Component, Prop } from 'vue-property-decorator'
@Component

export default class PlanRunStatusAll extends Vue {
    @Prop() status!: number

//   1：运行中（绿）
// 2：已结束（灰）
// 3：未开始（黄）
// 4：已停用（红）
}
